import { forwardRef, HTMLProps, ReactNode } from 'react';
import cx from 'classnames';

import styles from './Layout.module.scss';

export type LayoutContentProps = Pick<HTMLProps<HTMLDivElement>, 'className'> & {
  children?: ReactNode;
};

const LayoutContent = forwardRef<HTMLDivElement, LayoutContentProps>(
  ({ children, ...htmlProps }, ref): JSX.Element => (
    <div ref={ref} {...htmlProps} className={cx(styles.content, htmlProps.className)}>
      {children}
    </div>
  )
);

export default LayoutContent;
